import { t } from '../i18n';
import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';

const NotFound = () => {
  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="text-center max-w-xl">
        <div className="mb-8 text-primary text-9xl font-bold">404</div>
        <h1 className="text-4xl font-bold mb-4">{t("Page Not Found")}</h1>
        <p className="text-white/70 mb-8">
          {t("The page you are looking for doesn't exist or has been moved.")}
        </p>
        <div className="flex flex-wrap justify-center gap-4">
          <Link to="/" className="btn btn-primary">
            <Home className="mr-2 h-5 w-5" />
            {t("Go Home")}
          </Link>
          <button 
            onClick={() => window.history.back()} 
            className="btn btn-outline"
          >
            <ArrowLeft className="mr-2 h-5 w-5" />
            {t("Go Back")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;